import type { FaqFragment } from '@mnd-apps/public/wp-generated/types';
import Accordion, { type AccordionItems } from '@mnd-frontend/ui/public/components/Accordion';
import Heading from '@mnd-frontend/ui/public/components/typography/Heading';
import Wysiwyg from '@mnd-frontend/ui/public/components/typography/Wysiwyg';
import ContentMaxWidth from '@mnd-frontend/ui/public/components/wrappers/ContentMaxWidth';
import {
  BREAKPOINTS,
  SPACING_2,
  SPACING_3,
  SPACING_6,
  SPACING_8,
  SPACING_10,
} from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

const ModuleContainer = styled.section`
  margin: ${SPACING_6} ${SPACING_2};
  
  @media (min-width: ${BREAKPOINTS.XXL}px) { 
    margin: ${SPACING_10} auto;
  }
`;

const FaqWrapper = styled.div`
  @media (min-width: ${BREAKPOINTS.MD}px) { 
    display: flex;
    gap: ${SPACING_8};
  }

  h2 {
    margin-bottom: ${SPACING_3};
  }
`;

const formatItems = (rawItems: FaqFragment['faqs']): AccordionItems | undefined => {
  return rawItems?.map(item => ({
    id: item?.title?.split(' ').join('') ?? '',
    label: item?.title ?? '',
    content: <Wysiwyg htmlContent={item?.description ?? ''} />,
  }));
};

const FaqModule = ({ moduleData }: { moduleData: FaqFragment }) => {
  const formattedItems = formatItems(moduleData.faqs);

  if (!formattedItems) return null;

  return (
    <ModuleContainer>
      <ContentMaxWidth>
        <FaqWrapper>
          <Heading as="h2">{moduleData.title}</Heading>
          <Accordion items={formattedItems} hasBorder />
        </FaqWrapper>
      </ContentMaxWidth>
    </ModuleContainer>
  );
};

export default FaqModule;
